<template>
  <v-card flat dense>
    <v-card-title>
      {{ $t('ITEM.CREATE') }} {{ $t('CONTRACTS.ITEM') }}
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid">
        <create-contract-form
          v-model="form"
          :errors="errors"
          :building-complex-id="buildingComplexId"
          @input="emitter"
          @update-prop="updateProp(...arguments)"
        />
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        depressed
        color="primary"
        :disabled="!valid"
        @click="createRelatedCompany"
      >
        {{ $t('BUTTON.SAVE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import CreateContractForm from '@/modules/building_complexes_contracts/components/forms/CreateContractForm';

export default {
  name: 'CreateContract',
  components: { CreateContractForm },
  mixins: [formEditable],

  props: {
    buildingComplexId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      valid: false,
      form: {}
    };
  },

  methods: {
    cancel() {
      this.$emit('cancel');
    },

    createRelatedCompany() {
      this.$emit('create', { ...this.form });
    }
  }
};
</script>
